import { Component, Vue, Prop } from 'vue-property-decorator'

@Component

export default class TextField extends Vue {

  private showHints: boolean = false;

  @Prop()
  private indicators!: boolean;

  @Prop()
  private id?: string;

  @Prop()
  private className?: string;
  
  @Prop()
  private label?: string;

  @Prop()
  private type?: string;

  @Prop()
  private placeholder?: string;

  @Prop()
  private isValid?: boolean;

  @Prop()
  private value!: string;

  private get Listeners () {

    const {input, ...otherListeners} = this.$listeners;

    return {...otherListeners};
  }

  private handleInput (event: Event) {

    this.$emit('input', (event.target as HTMLInputElement).value)
  }

  private handleNotice () {
    
    if (!this.isValid && this.value.length > 0) {
      
      return this.showHints = true;
    }

    return this.showHints = false;
  }

}